// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7892) return "static/chunks/7892-9c5b43d6a05dd363.js";
	if (chunkId === 8765) return "static/chunks/8765-66fcca7d35adaef6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1589":"631a6763b917fb89","1835":"19970aa3f73d7026","2297":"951cacc9dcf3f07f","3860":"c2de9e93cb6c11be","7069":"27da95924fef2a36","7568":"cc78f6567e82cbe5","7643":"b4e58bb9cb32b492","8642":"5c72bdb4ce4736b7","8797":"8e104db6fc58e4cc","9334":"e0f9d358b7e6b9d6"}[chunkId] + ".js";
};